module.exports = __webpack_public_path__ + "front/img/kv06.ef7fa584.png";